import { render, staticRenderFns } from "./projects-final-report.vue?vue&type=template&id=9e3986a0&scoped=true&"
import script from "./projects-final-report.vue?vue&type=script&lang=js&"
export * from "./projects-final-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3986a0",
  null
  
)

export default component.exports